import { lazy } from "react";

const routes = [
  {
    path: "/payment-gateways",
    element: lazy(() => import("../../pages/Settings/PaymentGateways")),
  },
];

export default routes;
